module.exports = __webpack_public_path__ + "img/setting.487ad6c5.png";